<template>
  <div
    v-if="visible"
    class="login-failure-modal-overlay"
    @click.self="handleClose"
  >
    <div class="login-failure-modal">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-exclamation-triangle" style="color: #f0ad4e; margin-right: 10px;"></i>
          {{ title }}
        </h4>
      </div>
      <div class="modal-body">
        <p>{{ body }}</p>
      </div>
      <div class="modal-footer">
        <button ref="confirmButton" class="btn btn-primary" @click="handleConfirm">
          확인
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginFailureModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    body: {
      type: String,
      default: ""
    }
  },
  watch: {
    visible(show) {
      if (show) this.focusConfirmButton();
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
    if (this.visible) this.focusConfirmButton();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    focusConfirmButton() {
      this.$nextTick(() => {
        if (this.$refs.confirmButton) this.$refs.confirmButton.focus();
      });
    },
    handleConfirm() {
      this.$emit("close");
      this.$emit("confirm");
    },
    handleClose() {
      this.$emit("close");
    },
    handleKeydown(event) {
      if (!this.visible) return;
      if (event.key === "Escape" || event.keyCode === 27) {
        event.preventDefault();
        this.handleClose();
      } else if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault();
        this.handleConfirm();
      }
    }
  }
};
</script>

<style scoped>
.login-failure-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.login-failure-modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.modal-body {
  padding: 24px;
  color: #666;
  font-size: 1rem;
  line-height: 1.5;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-primary:active {
  background-color: #004085;
}
</style>
